<template>
    <div data-test="page">
        <StoryblokComponent v-for="blok in body" :key="blok._uid" v-bind="{ blok, ...$attrs }" />
    </div>
</template>

<script lang="ts" setup>
import type { SbBlokData } from '@/components/StoryblokComponent.vue';

defineProps<{ body: SbBlokData[] }>();
</script>
